import {BASE_LAYERS} from '@apps-common/ui-maps/constants';
import {changeMapView, setOverlayOn} from '@explorer/actions/map';

export const buildMapActions = storedState => {
  const actions = [];
  if (storedState.map) {
    if (storedState.map.center || storedState.map.zoom) {
      actions.push(
        changeMapView({
          center: storedState.map.center ? storedState.map.center : undefined,
          zoom: storedState.map.zoom,
        })
      );
    }

    if (storedState.map.overlays) {
      storedState.map.overlays.forEach(overlay => {
        // skip base layer selection to use local storage as source of truth
        // easiest change without changing how blobz storage works
        if (!Object.values(BASE_LAYERS).includes(overlay.name)) {
          actions.push(setOverlayOn(overlay));
        }
      });
    }
  }
  return actions;
};
